import React from 'react';
import './footer.css';
import logo from '../../images/logo.png';

// Using react-icons for better consistency
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from 'react-icons/fa';

const social = [
  {
    social: 'facebook',
    icon: FaFacebookF,
    link: 'https://www.facebook.com/erguearquitetura/',
  },
  {
    social: 'instagram',
    icon: FaInstagram,
    link: 'https://www.instagram.com/erguearquitetura/',
  },
  {
    social: 'linkedin',
    icon: FaLinkedinIn,
    link: 'https://www.linkedin.com/company/ergue-arquitetura/',
  },
  {
    social: 'whatsapp',
    icon: FaWhatsapp,
    link: 'https://wa.me/244925482610?text=Olá!%20Gostaria%20de%20saber%20mais%20sobre%20os%20serviços%20da%20ERGUE%20Arquitetura.',
  },
];

const quickLinks = [
  { name: 'Início', href: '#home' },
  { name: 'Serviços', href: '#services' },
  { name: 'Sobre', href: '#about' },
  { name: 'Portfolio', href: '#portfolio' },
  // { name: 'Contacto', href: '#contact' },
];

const services = [
  'Arquitectura Residencial',
  'Arquitectura Comercial',
  'Design de Interiores',
  'Consultoria',
  'Gestão de Projetos',
];

const getCurrentYear = () => {
  return new Date().getFullYear();
};

const Footer = () => {
  return (
    <footer className='footer' id='contact'>
      <div className='container'>
        <div className='footer__content'>
          {/* Company Info Section */}
          <div className='footer__section footer__brand'>
            <div className='footer__logo'>
              <img src={logo} alt='Ergue Arquitetura Logo' />
            </div>
            <h3 className='footer__brand-name'>ERGUE Arquitetura</h3>
            <p className='footer__description'>
              Onde cada construção é uma expressão de excelência e inovação.
              Juntos "ERGUEmos" o potencial de cada espaço.
            </p>
            <div className='footer__social'>
              {social.map((item, index) => (
                <a
                  key={index}
                  href={item.link}
                  className='footer__social-link'
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label={`Seguir no ${item.social}`}
                >
                  <item.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links Section */}
          <div className='footer__section'>
            <h4 className='footer__section-title'>Navegação</h4>
            <ul className='footer__links'>
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className='footer__link'>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Section */}
          <div className='footer__section'>
            <h4 className='footer__section-title'>Serviços</h4>
            <ul className='footer__links'>
              {services.map((service, index) => (
                <li key={index}>
                  <span className='footer__service'>{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div className='footer__section'>
            <h4 className='footer__section-title'>Contacto</h4>
            <div className='footer__contact'>
              <div className='footer__contact-item'>
                <FaMapMarkerAlt className='footer__contact-icon' />
                <div>
                  <p>Benguela & Namibe</p>
                  <p>Angola</p>
                </div>
              </div>
              <div className='footer__contact-item'>
                <FaPhone className='footer__contact-icon' />
                <p>+244925482610</p>
              </div>
              <div className='footer__contact-item'>
                <FaEnvelope className='footer__contact-icon' />
                <p>info@erguearquitetura.ao</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className='footer__bottom'>
          <div className='footer__copyright'>
            <p>
              © 2020 - {getCurrentYear()} ERGUE Arquitetura. Todos os direitos
              reservados.
            </p>
          </div>
          <div className='footer__credits'>
            <a
              href='https://devcomtrema.pt/'
              target='_blank'
              rel='noopener noreferrer'
              className='footer__credit-link'
            >
              Desenvolvido por DëV
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
